import { createFileRoute } from '@tanstack/react-router';

import { getLocalizedTitle } from '../title';

export const Route = createFileRoute('/_app/clients/')({
  head: () => ({
    meta: [
      {
        title: getLocalizedTitle('clients.clients.page_title', 'Clients'),
      },
    ],
  }),
});
